import { useEffect, useRef, useState } from 'react';
import { TFunction } from 'next-i18next';
import { VideoReelModel } from '@/models';
import Video from './Video';
import Comments from './Comments';

interface PostProps {
  video: VideoReelModel;
  t: TFunction;
  dispatch: (value: any) => void;
  onPlayVideo: (video: VideoReelModel) => void;
}

const Post = ({ video, t, dispatch, onPlayVideo }: PostProps) => {
  const [isShowComment, setIsShowComment] = useState<boolean>(false);

  return (
    <>
      <div
        id={`video-${video.id}`}
        className="tw-relative tw-flex tw-items-center tw-justify-center tw-gap-[80px]"
      >
        <div className="tw-w-[100vw] tw-h-[calc(100dvh-70px)] sm:tw-w-[270px] sm:tw-h-[480px] xl:tw-w-[304px] xl:tw-h-[540px] 2xl:tw-w-[366px] 2xl:tw-h-[650px] 3xl:tw-w-[405px] 3xl:tw-h-[720px]">
          <Video
            video={video}
            t={t}
            dispatch={dispatch}
            onToggleComment={() => setIsShowComment(!isShowComment)}
            onPlayVideo={() => onPlayVideo(video)}
          />
        </div>
        <div
          className={`${
            isShowComment ? 'animate-expanding' : 'tw-hidden'
          } tw-absolute tw-top-[80px] tw-pb-[70px] sm:tw-relative sm:tw-top-0 sm:tw-pb-0 tw-w-[100vw] tw-h-[calc(100dvh-80px)] sm:tw-w-[270px] sm:tw-max-w-[405px] sm:tw-h-[480px] xl:tw-w-[304px] xl:tw-h-[540px] 2xl:tw-w-[366px] 2xl:tw-h-[650px] 3xl:tw-w-[405px] 3xl:tw-max-w-[405px] 3xl:tw-h-[720px] tw-overflow-hidden`}
        >
          <Comments
            show={isShowComment}
            video={video}
            t={t}
            dispatch={dispatch}
            onCloseComment={() => {
              setIsShowComment(false);
            }}
          />
        </div>
      </div>
    </>
  );
};

export default Post;
